import { styled } from "styled-components";

export const UnstyledList = styled.ul`
  padding-left: 0;

  list-style: none;
`;
